<template>
  <div>
    <a-modal
      centered
      title="查询微信支付结果"
      v-model="visible"
      @cancel="onClose"
      @ok="onClose"
      :maskClosable="false"
      width="1100px"
    >
      <a-spin :spinning="spinning">
        <data-grid
          ref="dataGrid"
          :columns="columns"
          api="GetPlatformPayRecord"
          v-model="data"
          :params="params"
          :pagination="false"
          rowKey="PayOrderId"
          :rowAction="false"
          dataField="Data"
          :props="{
            scroll: {
              x: false,
              y: 'calc(100vh - 300px)'
            }
          }"
          bordered
          :onLoad="onLoad"
        >
          <template slot="CanRefundAmount" slot-scope="text, record">
            <div
              v-if="
                resConfig.IsOnlineRefund &&
                  (record.PayStatus == 1 || record.PayStatus == 2) &&
                  Number(record.MaxRefundAmount) > 0
              "
            >
              <a-input-number
                v-model="record.CanRefundAmount"
                :max="record.MaxRefundAmount"
                :min="0"
                style="width:70px"
                size="small"
              ></a-input-number>
              <a-popconfirm
                title="确定退款吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="onRefund(record)"
              >
                <a-button size="small" type="primary">退款</a-button>
              </a-popconfirm>
            </div>
            <div style="text-align:right" v-else>0</div>
          </template>
        </data-grid>
      </a-spin>
    </a-modal>
    <a-modal
      centered
      title="查询微信支付结果"
      v-model="visibleRes"
      @cancel="onCloseRes"
      @ok="onCloseRes"
      :maskClosable="false"
      width="900px"
    >
      <div class="result-box">
        <div
          class="status-info"
          v-if="payResult.TradeState == 'SUCCESS'"
          style="color:#3dac07"
        >
          <a-icon type="check-circle" />
          支付成功
        </div>
        <div
          class="status-info"
          v-else-if="payResult.TradeState == 'REFUND'"
          style="color:#f80"
        >
          <a-icon type="info-circle" />
          转入退款
        </div>
        <div
          class="status-info"
          v-else-if="payResult.TradeState == 'REVOKED'"
          style="color:#f40"
        >
          <a-icon type="close-circle" />
          已撤销
        </div>
        <div
          class="status-info"
          v-else-if="payResult.TradeState == 'NOTPAY'"
          style="color:#f50"
        >
          <a-icon type="close-circle" />
          未支付
        </div>
        <div
          class="status-info"
          v-else-if="payResult.TradeState == 'CLOSED'"
          style="color:#f00"
        >
          <a-icon type="close-circle" />
          已关闭
        </div>
        <div
          class="status-info"
          v-else-if="payResult.TradeState == 'USERPAYING'"
          style="color:#1890ff"
        >
          <a-icon type="info-circle" />
          用户支付中……
        </div>
        <div class="status-info" v-else style="color:#f00">
          <a-icon type="info-circle" />
          支付失败
        </div>
        <p>
          <label>支付金额：</label
          ><span class="pay-amount">{{
            payResult.TotalFee ? payResult.TotalFee / 100 : 0
          }}</span>
          元
        </p>
        <p v-if="payResult.TradeState == 'SUCCESS'">
          <label>微信支付单号：</label
          ><span>{{ payResult.TransactionId }}</span>
        </p>
      </div>
    </a-modal>
    <a-modal
      centered
      title="退款记录"
      v-model="visibleRefund"
      @cancel="onCloseRefund"
      @ok="onCloseRefund"
      :maskClosable="false"
      width="820px"
    >
      <data-grid
        ref="refundDataGrid"
        :columns="refundColumns"
        api="PMS_RefundQuery"
        v-model="refundData"
        :params="refundParams"
        :pagination="false"
        rowKey="refund_id"
        :rowAction="false"
        dataField="Data"
        bordered
      />
    </a-modal>
  </div>
</template>
<script>
import "./rms.less";
import { DataGrid } from "@/components/dataGrid";
import { accSub, accDiv } from "@/utils/common";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    DataGrid
  },
  data() {
    return {
      visible: false,
      orderId: "",
      payResult: {},
      baseColumns: [
        {
          title: "序号",
          width: "60px", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "支付状态",
          width: 120,
          dataIndex: "PayStatusName"
        },
        {
          title: "备注",
          dataIndex: "PayRemark",
          align: "left",
          customRender: text => {
            if (text) {
              const h = this.$createElement;
              const arr = text.split("\r\n").map(el => {
                return h("p", el);
              });
              return h("div", [arr]);
            }
          }
        },
        {
          title: "金额",
          width: 80,
          align: "right",
          dataIndex: "TotalAmount"
        },
        {
          title: "已退金额",
          width: 90,
          align: "right",
          dataIndex: "RefundAmount"
        },

        {
          title: "操作",
          dataIndex: "PayOrderId",
          width: 260,
          align: "right",
          customRender: (text, record) => {
            const check = {
              click: () => {
                this.getOrderQuery(record.PayOrderId);
              }
            };
            const checkRefund = {
              click: () => {
                this.checkRefund(record.PayOrderId);
              }
            };
            let btns = "";
            if (
              Number(record.RefundAmount) > 0 &&
              this.resConfig.IsOnlineRefund
            ) {
              btns = (
                <a-button size="small" type="primary" {...{ on: checkRefund }}>
                  查询退款进度
                </a-button>
              );
            }
            return (
              <div>
                {btns}
                <a-button
                  size="small"
                  type="primary"
                  style="margin-left:2px"
                  {...{ on: check }}
                >
                  向微信确认支付结果
                </a-button>
              </div>
            );
          }
        }
      ],
      columns: [],
      params: {},
      data: [],
      visibleRes: false,
      refundLoading: false,
      refundParams: {},
      refundData: [],
      visibleRefund: false,
      refundColumns: [
        {
          title: "序号",
          width: "60px", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "退款金额",
          width: 120,
          dataIndex: "refund_fee",
          customRender: text => {
            return accDiv(text, 100);
          }
        },
        {
          title: "退款账号",
          dataIndex: "refund_recv_accout"
        },
        {
          title: "退款状态",
          width: 150,
          dataIndex: "refund_status",
          customRender: text => {
            if (text == "SUCCESS") {
              return <a-badge status="success" text="成功" />;
            } else {
              <a-badge status="error" text="失败" />;
            }
          }
        },
        {
          title: "退款时间",
          width: 170,
          dataIndex: "refund_success_time"
        }
      ],
      resConfig: {},
      spinning: false
    };
  },

  created() {},
  methods: {
    show(orderId) {
      this.visible = true;
      this.visibleRes = false;
      this.orderId = orderId;
      this.data = [];
      this.params = {
        Id: orderId
      };
      // this.getOrderQuery();
      this.columns = cloneDeep(this.baseColumns);
      this.getConfig();
    },
    getConfig() {
      this.spinning = true;
      this.$post("GetRestaurantConfig", {}).then(res => {
        this.resConfig = res.Data;
        this.spinning = false;
        if (this.resConfig.IsOnlineRefund) {
          this.columns.splice(5, 0, {
            title: "可退金额",
            width: 140,
            scopedSlots: { customRender: "CanRefundAmount" }
          });
        }
      });
    },
    onLoad(res) {
      res.Data.forEach(el => {
        if (el.PayStatus == 1 || el.PayStatus == 2) {
          el.CanRefundAmount = accSub(el.TotalAmount, el.RefundAmount);
        } else {
          el.CanRefundAmount = 0;
        }
        el.MaxRefundAmount = Number(el.CanRefundAmount);
      });
      return res;
    },
    getOrderQuery(payOrderId) {
      this.$post("RMS_GetOrderQuery", {
        RestaurantOrderId: this.orderId,
        IsSettleAfterCheck: true,
        payOrderId: payOrderId
      }).then(res => {
        this.payResult = res.Data;
        this.visibleRes = true;
      });
    },
    checkRefund(payOrderId) {
      this.refundParams = {
        Id: payOrderId
      };
      this.visibleRefund = true;
    },
    onRefund(record) {
      this.spinning = true;
      this.$post("PMS_Refund", {
        PayOrderId: record.PayOrderId,
        TotalFee: record.TotalAmount,
        RefundFee: Number(record.CanRefundAmount)
      })
        .then(() => {
          this.spinning = false;
          this.$refs.dataGrid.reload();
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    onClose() {
      this.$emit("update");
      this.visible = false;
    },
    onCloseRes() {
      this.visibleRes = false;
      this.$refs.dataGrid.reload();
    },
    onCloseRefund() {
      this.visibleRefund = false;
      this.$refs.dataGrid.reload();
    }
  }
};
</script>

<style lang="less" scoped></style>
